export default __webpack_public_path__ + "6d7a749f5b9f8ce1ae13597ca2e539af.woff2";